import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import APITransport from "../../../../redux/actions/apitransport/apitransport";
import MembersTable from "../Project/MembersTable";
import GetOragnizationUsersAPI from "../../../../redux/actions/api/Organization/GetOragnizationUsers";

const Members = () => {
  const dispatch = useDispatch();
  const { orgId } = useParams();
  const OrganizationUserData = useSelector(
    (state) => state.getOrganizationUsers.data
  );

  const getOrganizationMembersData = () => {
    if (!orgId) return;
    const organizationUsersObj = new GetOragnizationUsersAPI(orgId);
    dispatch(APITransport(organizationUsersObj));
  };

  useEffect(() => {
    getOrganizationMembersData();
  }, []);

  // console.log("OrganizationUserData", OrganizationUserData)

  return <MembersTable dataSource={OrganizationUserData} type="organization" />;
};

export default Members;
